/**
 * @generated SignedSource<<d3a5fe6c93b70a1210535f542d603176>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking$data = {
  readonly issueByKey: {
    readonly projectField: {
      readonly project: {
        readonly projectStyle: JiraProjectStyle | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly rankField: {
    readonly jqlTerm: string;
  } | null | undefined;
  readonly userPreferences: {
    readonly isIssueViewHideDoneChildIssuesFilterEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking";
};
export type view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking$key = {
  readonly " $data"?: view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    }
  ],
  "kind": "Fragment",
  "name": "view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking",
  "selections": [
    {
      "args": (v1/*: any*/),
      "concreteType": "JiraJqlFieldWithAliases",
      "kind": "LinkedField",
      "name": "rankField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jqlTerm"
        }
      ]
    },
    {
      "args": (v1/*: any*/),
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isIssueViewHideDoneChildIssuesFilterEnabled"
        }
      ]
    },
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "issueKey"
        }
      ],
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issueByKey",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectField",
          "kind": "LinkedField",
          "name": "projectField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "projectStyle"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "caed8b79fdc58a1873dc2f66e30b7335";

export default node;
